export const API_URL = 'https://api.cognizata.com/api';
// export const API_URL = 'http://203.151.50.80:8000/api';
//export const API_V2_URL = 'http://127.0.0.1:3000';
export const API_V2_URL = 'https://api2.cognizata.com';
export default API_URL;
